import styled from 'styled-components';
import React from 'react';
import { Grow, GrowProps, Paper, Popper } from '@material-ui/core';
import { PopperProps } from '@material-ui/core/Popper/Popper';

export const MenuButton = styled.button`
    background: transparent;
    border: none;
    color: #fff;
    padding: 0;
    margin: 0;
    cursor: pointer;
`;

export const GrowStyled = styled<React.FC<GrowProps & { placement?: string }>>(
    Grow,
)`
    transform-origin: ${({ placement }) =>
        placement === 'button' ? 'center top' : 'center bottom'};
`;

export const PaperStyled = styled(Paper)`
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
        rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
        rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
`;

export const MenuListHeader = styled.div`
    display: grid;
    grid-auto-flow: column;
    gap: 1rem;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem;
    color: white;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: ${({ theme }) => theme.branding.primary.main};
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; ;
`;

export const PopperStyled = styled<React.FC<PopperProps>>(Popper)`
    left: 0px !important;
    top: 33px !important;
    width: 280px;
    z-index: 999;
`;
